var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-breadcrumb",attrs:{"id":"product-services"}},[_c('div',{staticClass:"container-fluid"},[_c('headerProduct'),_c('tablaProduct')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }